"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgGiftStep1(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M19.272 8.849c1.232 0 2.226.994 2.226 2.226a2.223 2.223 0 01-2.226 2.226h4.373c.179 0 .318.14.318.319v3.18c0 .179-.14.318-.318.318h-.954v4.135a.955.955 0 01-.954.954H10.923a.955.955 0 01-.954-.954v-4.135h-.954a.314.314 0 01-.318-.318v-3.18c0-.18.139-.319.318-.319h4.373a2.222 2.222 0 01-2.226-2.226c0-1.232.993-2.226 2.226-2.226.666 0 1.282.278 1.67.765l1.272 1.64 1.272-1.64c.388-.487 1.004-.765 1.67-.765zM17.92 13.3h-3.18v7.117c0 .348.288.517.636.517h1.908c.348 0 .636-.17.636-.517V13.3zm-7.492-11.17c.132 0 .255.047.348.14l1.53 1.53a.484.484 0 01.14.348.485.485 0 01-.14.348l-9.94 9.94a.483.483 0 01-.348.14.484.484 0 01-.348-.14l-1.53-1.53A.484.484 0 010 12.56c0-.131.046-.255.14-.347l9.94-9.942a.486.486 0 01.348-.139zm8.844 7.99a.911.911 0 00-.686.308l-1.242 1.6h1.928a.954.954 0 000-1.908zm-5.884 0a.954.954 0 000 1.908h1.938l-1.252-1.6a.91.91 0 00-.686-.308zM11.665 6.87l.232.758.758.231-.758.232-.232.758-.232-.758-.757-.232.757-.231.232-.758zm-1.237-3.548L8.163 5.587l.828.827 2.265-2.265-.828-.827zm-6.184-.905l.464 1.515 1.515.464-1.515.464-.464 1.515L3.78 4.86l-1.515-.464 1.515-.464.464-1.515zm2.474-.494l.232.757.757.232-.757.232-.232.757-.232-.757-.758-.232.758-.232.232-.757zm-4.948 0l.232.757.758.232-.758.232-.232.757-.232-.757-.757-.232.757-.232.232-.757z",
    fill: "inherit",
    fillRule: "evenodd"
  }));
}

var _default = SvgGiftStep1;
exports.default = _default;